<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char05">
                <label class="label-caption">Vistoria</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center">{{ objView.protocolo }}</div>
            </div>            

            <div class="form-item-char10">
                <label class="label-caption">Data</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtvistoria) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ objView.nmestabelecimento }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Nro SIM</label>
                <div class="field-label">{{ objView.nrosim }}</div>
            </div>

            <div class="form-item-char40">
                <label class="label-caption">Responsável</label>
                <div class="field-label">{{ objView.nmresponsavel }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item-char20">
                <label class="label-caption">Início vistoria</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhinicio) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Encerramento vistoria</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhencerramento) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Atividade</label>
                <div class="field-label">{{ objView.nmatividade }}</div>
            </div>
        </div>
        

        <div class="row row-space">
            <div class="form-item-char40">
                <label class="label-caption">SIM</label>
                <div class="field-label">{{ objView.nmsim }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Fiscal</label>
                <div class="field-label">{{ objView.nmvistoriador }}</div>
            </div>
        </div>



        <div v-if="lsItens.length > 0" class="row row-space">
            <div
                v-for="item in lsItens"
                :key="item.id"
                class="form-item"
            >
                <label class="label-caption">{{ item.codigo }}</label>
                <div class="field-label field-label-center" :class="getClass(item.resultado)">{{ item.resultado }}</div>
            </div>
        </div>
        
        
        <div class="row-end">
            <button type="button" class="btn-small" @click="visualizarLaudo">Laudo</button>
            <button type="button" class="btn-small" :disabled="lsImagens.length==0" @click="abrirFotos">Fotos ({{ lsImagens.length }})</button>
            <button type="button" class="btn-small" @click="onClickEmail">Email</button>
            <button type="button" class="btn-small" @click="closeForm">Retornar</button>
        </div>
    </div>
    

    <div v-if="lsNc.length>0" class="table-wrapper">
        <table>
            <thead><tr>
                <th>Ítem</th>
                <th>Prazo</th>
                <th>Status</th>
                <th>Previsão</th>
                <th>Correção</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsNc" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char10 center">{{ obj.ref_cditem }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtprazo) }}</td>
                    <td class="col-width-char50">{{ obj.nmstatus }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.acdtprevista) }}</td>
                    <td>{{ obj.acdetalhamento }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    
    <div v-if="modalFotosAberto" class="modal-overlay">
        <div class="photos-modal">
            <div class="modal-header">
                <h3>Fotos da Vistoria</h3>
                <button class="btn-small" @click="modalFotosAberto = false">FECHAR</button>
            </div>

            <div v-if="loadingFotos" class="photos-loading">
                Carregando fotos...
            </div>

            <div v-else class="photos-grid">
                <img
                    v-for="(foto, index) in fotosCarregadas"
                    :key="foto.idanexo"
                    :src="foto.url"
                    class="photo-thumb"
                    :class="{ 'photo-thumb-active': index === fotoAtualIndex }"
                    @click="fotoAtualIndex = index"
                />
            </div>

            <div v-if="fotosCarregadas[fotoAtualIndex]" class="photo-preview">
                <img :src="fotosCarregadas[fotoAtualIndex].url" />
            </div>
        </div>
    </div>


    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="showOkModal=false" 
        @confirmed="showOkModal=false"
    />


    <EmailLaudoModal
        v-if="showEmailModal"
        @close="showEmailModal = false"
        @confirm="enviarEmailLaudo"
    />
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import EmailLaudoModal from '@/components/modals/EmailLaudoModal.vue';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const isLoading = ref(false);
const lsNc = ref([]);
const lsItens = ref([]);
const msgAlerta = ref(null);
const msgOkModal = ref(null);
const objView = ref({});
const showEmailModal = ref(false);
const showOkModal = ref(false);


const fotoAtualIndex = ref(0);
const fotosCarregadas = ref([]);
const loadingFotos = ref(false);
const lsImagens = ref([]);
const modalFotosAberto = ref(false);


async function abrirFotos(){
    modalFotosAberto.value = true;
    if (fotosCarregadas.value.length>0) return;
    loadingFotos.value = true;

    try{
        for (const anexo of lsImagens.value){
            if (anexo.storage_cdtipo === 2 && anexo.storage_status === 1) {
                const rUrl = await Api.genericPost('/operacoes/solicitar/download', {
                    id: anexo.id
                });

                if (rUrl.bolok === 1) {
                    fotosCarregadas.value.push({
                        ...anexo,
                        url: rUrl.download_url,
                        nome: rUrl.nome_arquivo
                    });
                }
            }
        }
        fotoAtualIndex.value = 0;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        loadingFotos.value = false;
    }
}


const closeForm = () => {emit('close');}


async function enviarEmailLaudo(payload){
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        showEmailModal.value = false;

        await Api.genericPost('/pla/vistoria/email', {
            id: objView.value.id,
            strparam1: payload.usarEnvolvidos ? '' : payload.emails
        });
        msgOkModal.value='Email adicionado a fila de envios!';
        showOkModal.value=true;

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function getClass(value) {
    if (!value) return ''; // protege contra undefined
    switch (value) {
        case 'CF': return 'cf';
        case 'CR': return 'cr';
        case 'NC': return 'nc';
        case 'NA': return 'na';
        default: return '';
    }
}


async function lerDados() {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/vistorias', {idep: globalStore.idep, id: props.idView});
        Object.assign(objView.value, req[0]);

        const reqItens = await Api.genericPost('/listas/vistorias/itens', {idreferencia: props.idView})
        lsItens.value = reqItens;
        
        const reqNC = await Api.genericPost('/dados/rac_nc', {
            idep: globalStore.idep,
            idreferencia: props.idView,
            strparam1: 'VISTORIA'});
        lsNc.value = reqNC;

        const reqImagens = await Api.genericPost('listas/vistorias/anexos', {
            idreferencia: props.idView
        });
        lsImagens.value = reqImagens || [];
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


function onClickEmail(){
    msgAlerta.value = null;
    showEmailModal.value = true;
}


async function visualizarLaudo() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const r = await Api.genericPost('/operacoes/solicitar/download', { id: objView.value.idlaudo });

        if (r.bolok === 1 && r.download_url) {
            window.open(r.download_url, '_blank');
        } else {
            msgAlerta.value = `ATENÇÃO: ${r.erro || 'Não foi possível abrir o anexo.'}`;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


onMounted(lerDados)
</script>


<style scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 1999;
    background: rgba(15, 23, 42, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
}

.photos-modal {
    width: min(1000px, 94vw);
    max-height: 90vh;
    overflow: auto;
    background: #fff;
    border-radius: 10px;
    padding: 16px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}

.photos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 10px;
    margin-bottom: 16px;
}

.photo-thumb {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    border: 2px solid #e2e8f0;
    cursor: pointer;
}

.photo-thumb-active {
    border-color: #2563eb;
}

.photo-preview {
    text-align: center;
}

.photo-preview img {
    max-width: 100%;
    max-height: 65vh;
    object-fit: contain;
    border-radius: 8px;
}
</style>